// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols
const toolbar = [
  'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent'
]

export default toolbar
